"use client";

type Props = {
    checked: boolean;
    onChange: (checked: boolean) => void;
    ariaLabel?: string;
    disabled?: boolean;
};

/** ②のチェックボックス（行選択・全選択等）。`accent-brand` で②選択色。 */
export function Checkbox({ checked, onChange, ariaLabel, disabled }: Props) {
    return (
        <input
            type="checkbox"
            checked={checked}
            disabled={disabled}
            onChange={(e) => onChange(e.target.checked)}
            aria-label={ariaLabel}
            className="size-3.5 shrink-0 cursor-pointer accent-brand"
        />
    );
}
